import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'


import imgHero from '../../images/hero_img_skill_validation.png'
import imgSectionOne from '../../images/img_skill_validation_01.png'
import imgSectionTwo from '../../images/img_skill_validation_02.png'
import imgSectionThree from '../../images/img_skill_validation_03.png'
import imgSectionFour from '../../images/img_skill_validation_04.png'
import imgSectionFive from '../../images/img_skill_validation_05.png'
import imgRoundedLeft from '../../images/rounded_left_white_bottom.png'
import imgRoundedRight from '../../images/rounded_right_bottom_red.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'
import imgRoundedLeftBottom from '../../images/circular_rounded_right.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'

class SkillValidation extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {
    const {
      globalGetLanguages,
      user
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text talent-acquisition">
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'SKILL_VALIDATION_BANNER_TITLE_1'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'SKILL_VALIDATION_BANNER_TITLE_2'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'SKILL_VALIDATION_BANNER_TITLE_3'))}</div>
              

              <div className='content-desc'>
                {renderHTML(translate(globalGetLanguages,'SKILL_VALIDATION_BANNER_TEXT'))}
              </div>

              <div className={`ban-link`}>
                <Link to={{pathname: `/register`, query: { plan: 'free' }}} className="try"
                  onClick={() => accesslog('skill-validation', 'button_start_free_plan')}
                >{translate(globalGetLanguages,'BUTTON_START_FREE_PLAN')}</Link>
                <a onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('skill-validation', 'button_talk_to_an_expert');
                }} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <div className={`ban-link hide`}>
                <a onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-left-top">
            <img src={imgRoundedLeftTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2  style={{ fontWeight: '700' }} className='m-b-24'>
                {renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_TITLE_1'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC_1'))}</p>
                  <p className='m-b-10'>{renderHTML(translate(globalGetLanguages,'TEXT_CAN_ACCESS'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_1_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_1_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_1_SUB_3'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_1_SUB_4'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionTwo} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 style={{ fontWeight: '700' }} className='m-b-24'>
                {renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_TITLE_2'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC_2'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_2_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_2_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_2_SUB_3'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_2_SUB_4'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_2_SUB_5'))}</li>
                  </ul>
                  
               <p className='m-t-30' style={{ fontSize: '16px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC'))}</p>

                </div>
              </div>
            </div> 
          </section>
      </div>

      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            
            <div className='flex-item-right' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 style={{ fontWeight: '700' }} className='m-b-24'>
                {renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_TITLE_3'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC_3'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_3_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_3_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_3_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
      </div>
      <div className="section-white" style={{position: 'relative'}}>
          <section className='flex-container relative'>

            <div className='flex-item-right' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 style={{ fontWeight: '700' }} className='m-t-0 m-b-24'>
                {renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_TITLE_4'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC_4'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_4_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_4_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_4_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
            <div className='flex-item-left' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionFour} />
              </div>
            </div>
            <img className="rounded-circular-right" src={imgRoundedLeftBottom} />
          </section>
      </div>

      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 style={{ fontWeight: '700' }} className='m-t-0 m-b-24'>
                {renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_TITLE_5'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_DESC_5'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_5_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_5_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_5_SUB_3'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_SKILL_VALIDATION_FEAURES_5_SUB_4'))}</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionFive} />
              </div>
            </div>
          </section>
          {/* <a href="#" className="vid-msg-right">
                <img src={imgRoundedRight} />
          </a> */}

      </div>

       <div className="section-red" style={{position: 'relative', overflow: 'hidden'}}>          
        <section className='p-t-50 p-b-50'>
            <div className='try-yourself'>
              <h1>Try it Yourself</h1>
              <h4>See the full range of assessments and interviews in our inventory. <br />Pick what fits your hiring needs and try them like a candidate would.</h4>
              <div className="card-try-yourself">
                <div className="weekly-text">
                  <Link className="btn-primary" to={{ pathname: `/assessments-and-interviews` }}
                    onClick={() => accesslog('skill-validation', 'button_explore_assessment_interview')}
                  >{renderHTML(translate(globalGetLanguages,'TEXT_EXPLORE_ASSESSMENT_INTERVIEW'))}</Link>
                </div>
              </div>
            </div>
        </section>
        <a href="#" className="vid-msg-left">
            <img src={imgRoundedLeft} />
        </a>
      </div>
      
      <div className="section-white single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Ready to Validate Skills with <br />Confidence?</h1>
              <h4>Create an assessment experience that reveals and validates true ability. <br />No more guesswork and the resulting cost of decision mistakes.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link to={{pathname: `/register`, query: { plan: 'free' }}} className="try"
                    onClick={() => accesslog('skill-validation', 'button_start_free_plan')}
                  >{translate(globalGetLanguages,'BUTTON_START_FREE_PLAN')}</Link>
                  <a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('skill-validation', 'button_talk_to_an_expert');
                  }} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
                </div>
                <Link className="request-demo-logged"  to={{ pathname: `/assessments-and-interviews` }}
                  onClick={() => accesslog('skill-validation', 'button_explore_assessment_interview')}
                >{renderHTML(translate(globalGetLanguages,'TEXT_EXPLORE_ASSESSMENT_INTERVIEW'))}</Link>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SkillValidation)
